export enum PayoutRequisitesTabs {
  Requisites = 'requisites',
  Limits = 'limits',
  Automation = 'automation',
  BalanceRedistribution = 'balance_redistribution',
}
